<template>
  <div class="circle-content circle-content--default start-step">
    <lazy-img :src="step.image" class="circle-content__img" />
    <div class="circle-content__title start-step__title fade-in" v-html="$t(step.title)"></div>
    <div class="circle-content__description start-step__description fade-in" v-html="$t(step.description)"></div>
  </div>
</template>

<script>
import Circle from '@/class/Circle';
import { Steps } from '@/models/steps';

export default new Circle(Steps.START).comp;
</script>

<style lang="scss">
.start-step {
  padding: 60px 40px 80px;
}

.start-step__title {
  font-size: 9em;
  width: 100%;
  text-align: center;
  line-height: 0.7;

  span {
    margin-left: 1.25em;
  }
}

.start-step__description {
  font-family: $accentFont;
  font-size: 3em;
  line-height: 1;
  text-align: center;
  text-transform: none;
  letter-spacing: normal;
  margin-top: 1.75em;
}

@media (max-width: 460px) {
  .start-step {
    padding: 60px 20px 30%;
  }

  .start-step__title {
    font-size: 8em;
  }

  .start-step__description {
    font-size: 2.6em;
    margin-top: 1em;
    letter-spacing: 2px;
  }
}

@media (min-width: 992.89px) {
  .start-step {
    padding: 80px 40px 130px;
  }
}
</style>
